module.exports = __webpack_public_path__ + "static/media/menu-settings.b73ea167.svg";